/*
 * vrtPSWorkshop.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSWorkshop: RouteRecordRaw = {
  path: '/powersteer/workshop',
  name: 'vrtPSWorkshop',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'powersteerworkshopehelpoperate',
      name: 'vrtPSWorkshopeHELPMain',
      component: () => import('./vpgPSWorkshopeHELPMain.vue'),
    },
    {
      path: 'powersteerworkshopehelpoperate/:cpinID',
      name: 'vrtPSWorkshopeHELPOperate',
      component: () => import('./vpgPSWorkshopeHELPOperate.vue'),
    },
    {
      path: 'powersteerfaultbook',
      name: 'vrtPSFaultbookList',
      component: () => import('./vpgPSFaultbookList.vue'),
    },
    {
      path: 'powersteerfaultbookoperate',
      name: 'vrtPSFaultbookOperate',
      component: () => import('./vpgPSFaultbookOperate.vue'),
    },
    {
      path: 'powersteerlogbookwscheckinout',
      name: 'vrtPSVLogbookWSCheckInOut',
      component: () => import('./vpgPSVLogbookWSCheckInOut.vue'),
    },
    {
      path: 'powersteerlogbookwscheckout',
      name: 'vrtPSVLogbookWSCheckOut',
      component: () => import('./vpgPSVLogbookWSCheckOut.vue'),
    },
    {
      path: 'powersteerlogbookwsoperate',
      name: 'vrtPSVLogbookWSOperate',
      component: () => import('./vpgPSVLogbookWSOperate.vue'),
    },
    {
      path: 'powersteerlogbookwsoperateaddedit',
      name: 'vrtPSVLogbookWSOperateAddEdit',
      component: () => import('./vpgPSVLogbookWSOperateAddEdit.vue'),
    },
    {
      path: 'powersteerlogbookwscheckin',
      name: 'vrtPSVLogbookWSCheckIn',
      component: () => import('./vpgPSVLogbookWSCheckIn.vue'),
    },
  ],
};

export default vrtPSWorkshop;
